import { Skeleton } from "@material-ui/lab";
import React from "react";

import TextPlaceholder from "@/features/placeholder/TextPlaceholder";
import { convertVariantToDimensions } from "@/helpers/user/avatar/avatarHelper";

const defaultLength = 1;
interface CommentPlaceholderProps {
  count?: number;
}
export const CommentPlaceholder: React.FC<CommentPlaceholderProps> = (
  props,
) => {
  const { count } = props;
  const { height, width } = convertVariantToDimensions("comment");
  return (
    <div className="flex flex-col max-w-[700px] w-full md:w-4/5">
      {new Array(count ?? defaultLength).fill(0).map((_, idx) => {
        return (
          <div className="flex items-center" key={idx.toString()}>
            <div className="p-4 pl-0">
              <Skeleton variant="circle" width={width} height={height} />
            </div>
            <div className="flex flex-col flex-1 space-y-4">
              <TextPlaceholder className="w-1/3" size="sm" />
              <TextPlaceholder className="w-4/5" size="sm" />
            </div>
          </div>
        );
      })}
    </div>
  );
};
